import { createContext, useContext } from 'react';

// Context to provide a container element for popovers inside dialogs
// This allows popovers to render inside the dialog's DOM tree,
// which is necessary for focus trapping to work correctly
const DialogContainerContext = createContext<HTMLElement | null>(null);

export const DialogContainerProvider = DialogContainerContext.Provider;
export const useDialogContainer = () => useContext(DialogContainerContext);
